import React from 'react';
import { Slider, Icon } from 'antd';
import { connect } from 'react-redux';
import { startSetYearSlider } from '../../actions/globalState';
import {objectFromRange} from '../../utils/utils';

export class YearSlider extends React.Component {

  onYearChange = (value) => {
    this.props.startSetYearSlider(value);
  }

  render() {
    const marks = objectFromRange(2016, 2037, 1);
    //console.log('marks', marks)
    return (
      <div className="icon-wrapper">
        <h3>Select year </h3>
        <Slider
        min={2016}
        max={2036}
          marks={marks} step={1}
          defaultValue={this.props.year}
          onChange={value => this.onYearChange(value)}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  year: state.globalState.populationForecast.year
});

const mapDispatchToProps = (dispatch) => ({
  startSetYearSlider: (year) => dispatch(startSetYearSlider(year))
});

export default connect(mapStateToProps, mapDispatchToProps)(YearSlider);


// WEBPACK FOOTER //
// ./src/components/populationForecast/YearSlider.js